export interface PillarArticle {
  key: string;
  image: string;
  href: string;
}

export const pillarArticles: PillarArticle[] = [
  {
    key: 'spreadsheet',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20spreadsheet%20grid%20on%20a%20laptop%20screen%20surrounded%20by%20neatly%20organized%20fashion%20product%20cards%20on%20a%20warm%20cream%20desk%2C%20soft%20natural%20light%2C%20editorial%20e-commerce%20workspace%20aesthetic%2C%20sage%20green%20and%20terracotta%20accents%2C%20high%20detail%2C%20no%20people&width=800&height=600&seq=pillar-01&orientation=landscape',
    href: '/usfans-spreadsheet-guide',
  },
  {
    key: 'review',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20desk%20scene%20with%20a%20notebook%20a%20five%20star%20rating%20icon%20and%20a%20pen%20on%20a%20soft%20blush%20pink%20background%2C%20warm%20lighting%2C%20editorial%20review%20aesthetic%2C%20clean%20composition%2C%20high%20detail%2C%20no%20people&width=800&height=600&seq=pillar-02&orientation=landscape',
    href: '/usfans-spreadsheet-guide',
  },
  {
    key: 'shipping',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20stacked%20cardboard%20shipping%20boxes%20with%20brown%20kraft%20paper%20and%20a%20tape%20dispenser%20on%20a%20warm%20sand%20colored%20surface%2C%20soft%20studio%20light%2C%20editorial%20logistics%20aesthetic%2C%20clean%20composition%2C%20high%20detail%2C%20no%20people&width=800&height=600&seq=pillar-03&orientation=landscape',
    href: '/usfans-spreadsheet-guide',
  },
  {
    key: 'coupon',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20discount%20tags%20and%20a%20pair%20of%20scissors%20on%20a%20soft%20olive%20green%20background%2C%20warm%20lighting%2C%20editorial%20savings%20aesthetic%2C%20clean%20composition%2C%20high%20detail%2C%20no%20people&width=800&height=600&seq=pillar-04&orientation=landscape',
    href: '/usfans-spreadsheet-guide',
  },
  {
    key: 'warehouse',
    image: 'https://readdy.ai/api/search-image?query=Orderly%20warehouse%20shelves%20with%20neatly%20stacked%20boxes%20and%20soft%20warm%20lighting%20on%20a%20terracotta%20and%20beige%20palette%2C%20editorial%20logistics%20aesthetic%2C%20clean%20composition%2C%20high%20detail%2C%20no%20people&width=800&height=600&seq=pillar-05&orientation=landscape',
    href: '/usfans-spreadsheet-guide',
  },
  {
    key: 'legit',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20shield%20icon%20and%20a%20magnifying%20glass%20on%20a%20clean%20warm%20cream%20surface%2C%20soft%20daylight%2C%20editorial%20safety%20and%20trust%20aesthetic%2C%20calm%20composition%2C%20high%20detail%2C%20no%20people&width=800&height=600&seq=pillar-06&orientation=landscape',
    href: '/usfans-spreadsheet-guide',
  },
  {
    key: 'product',
    image: 'https://readdy.ai/api/search-image?query=A%20side%20by%20side%20comparison%20of%20two%20folded%20sweaters%20in%20different%20colors%20on%20a%20warm%20taupe%20surface%2C%20soft%20natural%20light%2C%20editorial%20product%20comparison%20aesthetic%2C%20clean%20composition%2C%20high%20detail%2C%20no%20people&width=800&height=600&seq=pillar-07&orientation=landscape',
    href: '/usfans-spreadsheet-guide',
  },
  {
    key: 'seller',
    image: 'https://readdy.ai/api/search-image?query=A%20minimal%20storefront%20concept%20with%20a%20small%20hanging%20sign%20and%20folded%20clothing%20on%20a%20warm%20khaki%20background%2C%20soft%20daylight%2C%20editorial%20seller%20aesthetic%2C%20clean%20composition%2C%20high%20detail%2C%20no%20people&width=800&height=600&seq=pillar-08&orientation=landscape',
    href: '/usfans-spreadsheet-guide',
  },
  {
    key: 'qc',
    image: 'https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20over%20a%20folded%20garment%20with%20a%20measuring%20tape%20on%20a%20soft%20warm%20grey%20surface%2C%20editorial%20quality%20control%20aesthetic%2C%20clean%20composition%2C%20high%20detail%2C%20no%20people&width=800&height=600&seq=pillar-09&orientation=landscape',
    href: '/usfans-spreadsheet-guide',
  },
  {
    key: 'buying',
    image: 'https://readdy.ai/api/search-image?query=A%20filled%20shopping%20bag%20with%20neatly%20folded%20clothing%20and%20a%20receipt%20on%20a%20warm%20beige%20surface%2C%20soft%20daylight%2C%20editorial%20buying%20aesthetic%2C%20clean%20composition%2C%20high%20detail%2C%20no%20people&width=800&height=600&seq=pillar-10&orientation=landscape',
    href: '/usfans-spreadsheet-guide',
  },
];